import {strEnum} from "../../types";
import {Observable} from "rxjs";

/**
 * Dependent on DEV branching strategy
 */
export const TCI_APP_FEATURE_TYPE = strEnum([
    "ENV_ALERT",
    "APP_AUTO_SCALE",
    "APP_MONITORING",
    "APP_CONN_HAM_MENU",
    "APP_STATUS_FILTER"
]);
export type TCI_APP_FEATURE_TYPE = keyof typeof TCI_APP_FEATURE_TYPE;

/**
 * interface ITCIAppFeature
 */
export interface ITCIAppFeature {
    enabled: boolean;
}

/**
 * interface ITCIAppFeatures
 */
export interface ITCIAppFeatures {
    [feature_type: string]: ITCIAppFeature;
}

export class BaseTCIAppFeatures implements ITCIAppFeatures {
    [feature_type: string]: ITCIAppFeature;
}

export interface ITCIAppFeatureService {


    /**
     * get App Features
     */
    getAppFeatures(): Observable<ITCIAppFeatures>;

    /**
     * Set app feature
     * @param type
     * @param value
     */
    setAppFeature(type: TCI_APP_FEATURE_TYPE, value: ITCIAppFeature): void;
}

export abstract class BaseTCIAppFeatureService implements ITCIAppFeatureService {
    protected appFeatures: ITCIAppFeatures;

    constructor() {
        this.appFeatures = {};
    }

    /**
     * get App Features
     */
    getAppFeatures(): Observable<ITCIAppFeatures> {
        return Observable.of(this.appFeatures);
    }

    /**
     * Set app feature
     * @param type
     * @param value
     */
    setAppFeature(type: TCI_APP_FEATURE_TYPE, value: ITCIAppFeature): void {
        this.appFeatures[type as string] = value;
    }
}
